import * as Sentry from "@sentry/browser";

const sentryConfig = {
  dsn: "https://70bf61fff0bb7136f496d86287a772c4@o4505947962146816.ingest.us.sentry.io/4507023340208128",
  integrations: [
    Sentry.browserTracingIntegration(),
  ],

  environment: window?.MoMA?.appInfo?.environment || "production",

  allowUrls: ["localhost", /^https:\/\/.*.moma\.org/],
  ignoreErrors: [
    "fbq is not defined",
    "Can't find variable: fbq",
  ],

  tracePropagationTargets: [
    "localhost",
    /^https:\/\/local.moma\.org/,
    /^https:\/\/staging.moma\.org/,
    /^https:\/\/www.moma\.org/
  ],

  tracesSampleRate: 0.1,
};

if (window?.MoMA?.appInfo?.environment === "development") {
  sentryConfig.tracesSampleRate = 0.0;
} else if (window?.MoMA?.appInfo?.environment === "staging") {
  sentryConfig.tracesSampleRate = 1;
}

Sentry.init(sentryConfig);

if (window?.MoMA?.userProperties === undefined) {
  Sentry.setUser({});
} else if (window?.MoMA?.userProperties?.userId) {
  Sentry.setUser({ id: window.MoMA.userProperties.userId });
}
